import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { formatFileInlineTemplateString } from "@tellescope/utils";

type MessagingFile = TellescopeModelFromName<"files">;

/**
 * Appends inline file-link template placeholders to a plain-text (SMS) message,
 * one per file on its own line.
 */
export const buildSmsMessageWithFiles = (message: string, files: MessagingFile[]): string => {
  if (!files.length) return message;
  return message + files.reduce<string>((acc, file) => `${acc} ${formatFileInlineTemplateString(file)}`, "\n");
};

/**
 * Appends inline file-link template placeholders to an HTML (email / Zendesk) message,
 * each wrapped in its own line break + span.
 */
export const buildHtmlMessageWithFiles = (html: string, files: MessagingFile[]): string => {
  if (!files.length) return html;
  return (
    html +
    files.reduce<string>((acc, file) => `${acc}<br /><span>${formatFileInlineTemplateString(file)}</span>`, "<br />")
  );
};
